// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_bTm","cls2":"common-cls2_uZA common-cls1_bTm"};